import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MAT_DATE_LOCALE,MAT_DATE_FORMATS,DateAdapter } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, FormsModule } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { JwtService } from '../../../../../../shared/services/jwt.service';
import { JwtUserModel } from '../../../../../../shared/models/jwt-user.model';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CargoLaboralService } from '../../../_core/services/cargolaboral.service';
import { TrabajadorService } from '../../../_core/services/trabajador.service';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';
import { Alert } from 'selenium-webdriver';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
	selector: "m-dialog-prorroga-contrato",
	templateUrl: "./dialog-prorroga-contrato.component.html",
	styleUrls: ["./dialog-prorroga-contrato.component.scss"],
	providers: [
		DatePipe,
		{ provide: MAT_DATE_LOCALE, useValue: "es" },
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE],
		},
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
	],
})
export class DialogProrrogaContratoComponent implements OnInit {
	formMACRO: FormGroup;

	viewLoading: boolean = false;
	usuario: string;
	jwtUser: JwtUserModel;
	protected _onDestroy = new Subject<void>();
	array_tipoContrato: any = [];
	public filterTipoContrato: FormControl = new FormControl();
	public filtered_TipoContrato: ReplaySubject<any> = new ReplaySubject<any>();
	isNow: any = new Date();

	Fecha_igual : Date;
	FechasIguales: Boolean = false;
	ContFechasIguales: number = 0;
	NoFechasIguales: any = [];

	ArraySeleccion: any = [];

	chkPorDias = new FormControl(false);
	chkPorPeriodo = new FormControl(false);

	esDiferente: Boolean = true;

	constructor(
		public dialogRef: MatDialogRef<DialogProrrogaContratoComponent>,
		private _formBuilder_lote: FormBuilder,
		private datePipe: DatePipe,
		public trabajador_s: TrabajadorService,
		private jwtService: JwtService,
		public toastr: ToastrManager,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		//console.log(this.data);
		this.jwtUser = this.jwtService.getUser();
		this.create_form();
		this.getTipoContrato_cbo();
		this.ValidarFechas(this.data);

		this.formMACRO.controls.DiasRenovarContrato.disable();

		if(this.FechasIguales){
			const addDays = (date: Date, days: number): Date => {
				let result = new Date(date);
				result.setDate(result.getDate() + days);
				return result;
			};
			const FechaAteriorFinContrato = new Date(this.Fecha_igual);
			const NuevaFechaInicioContrato: Date = addDays(FechaAteriorFinContrato, 1);
			this.formMACRO.controls.FechaInicio.setValue(moment({year: NuevaFechaInicioContrato.getFullYear(), month: NuevaFechaInicioContrato.getMonth(), day: NuevaFechaInicioContrato.getDate()}));
		}else{
			this.esDiferente = false;
			this.formMACRO.controls.DiasRenovarContrato.disable();
			this.chkPorPeriodo.setValue(true);
			// this.chkPorPeriodo.disable();
		}
		this.ArraySeleccion = this.data.datos;
	}


	create_form() {
		this.formMACRO = this._formBuilder_lote.group({
			TipoContrato: [null, Validators.required],
			FechaInicio: [null],
			FechaFin: [null],
			chkPorDias: [null],
			DiasRenovarContrato: [null],
			chkPorPeriodo: [null],
		});
	}

	onNoClick(): void {
		this.dialogRef.close({ rpta: false, data: [] });
	}

	onYesClick() {
		this.viewLoading = true;
		this.dialogRef.close(true);
	}

	//#region VALIDACIÓN DE FECHAS


	fecha : Date ;
	fechaMayor : Date ;
	obtenerFechaMayor(data){
		for (let i = 0; i < data.datos.length; i++) {
			var fechafin1 = data.datos[i].FinContrato;
			for (let j = 1; j < data.datos.length; j++) {
				var fechafin2 = data.datos[j].FinContrato;

				if (fechafin1 > fechafin2) {
					this.fechaMayor = fechafin1;
				} else {
					this.fechaMayor = fechafin2;
				}
			}
		}
	}

	obtenerFechaIgual(data){
		for (let i = 0; i < data.datos.length; i++) {
			var fechafin1 = data.datos[i].FinContrato;
			for (let j = 1; j < data.datos.length; j++) {
				var fechafin2 = data.datos[j].FinContrato;
				if ( fechafin1 == fechafin2 )
				{
					this.FechasIguales = true;
					this.Fecha_igual = data.datos[i].FinContrato;
				} else {
					this.FechasIguales = false;
					return;
				}
			}
		}
	}

	ValidarFechas(data) {
		if (data.datos.length > 1) {
			this.obtenerFechaMayor(data);
			this.obtenerFechaIgual(data)
		}else if (data.datos.length == 1){
			this.FechasIguales = true;
			this.Fecha_igual = data.datos[0].FinContrato;
		}
		console.log(this.fechaMayor);
	}

	calcularFechasPorDias() {
		const _controls = this.formMACRO.controls;

		let chkd = this.chkPorDias.value;
		let chkp = this.chkPorPeriodo.value;

		if (!chkd && !chkp){
			this.toastr.warningToastr(
				"Seleccione una opción: Por días o Por Periodo.",
				"Advertencia!",
				{
					toastTimeout: 2000,
					showCloseButton: true,
					animate: "fade",
					progressBar: true,
				}
			);
			return;
		}

		//Calculo por días
		if(chkd){
			if(this.FechasIguales){ // FECHAS IGUALES
				const addDays = (date: Date, days: number): Date => {
					let result = new Date(date);
					result.setDate(result.getDate() + days);
					return result;
				};
				const nrodias : number = _controls.DiasRenovarContrato.value;
				const FechaAteriorFinContrato = new Date(this.Fecha_igual);
				const NuevaFechaInicioContrato: Date = addDays(FechaAteriorFinContrato, 1);
				const NuevaFechaFinContrato: Date = addDays(NuevaFechaInicioContrato, nrodias);

				this.formMACRO.controls.FechaFin.setValue(moment({year: NuevaFechaFinContrato.getFullYear(), month: NuevaFechaFinContrato.getMonth(), day: NuevaFechaFinContrato.getDate()}));
			}else{ // FECHAS DIFERENTES

			}
		}

		//Periodo

	}

	//#endregion

	//#region VALIDACIÓN CHECKBOX
	checkPorDias(){
		let chkd = this.chkPorDias.value;

		if (chkd){
			this.chkPorPeriodo.setValue(false);
			this.formMACRO.controls.DiasRenovarContrato.setValue("");
			this.formMACRO.controls.DiasRenovarContrato.enable();
		}
	}

	checkPorPeriodo(){
		let chkp = this.chkPorPeriodo.value;

		if (chkp){
			this.chkPorDias.setValue(false);
			this.formMACRO.controls.DiasRenovarContrato.setValue("");
			this.formMACRO.controls.DiasRenovarContrato.disable();
			this.formMACRO.controls.FechaFin.setValue("");
		}
	}
	//#endregion

	//#region COMBO TIPO CONTRATO
	getTipoContrato_cbo() {
		this.trabajador_s._GetListarModelosContrato().subscribe(
			(data: any) => {
				data = data.filter((e) => e.Empresa === this.data.empresa);
				this.array_tipoContrato = data;
				this.filtered_TipoContrato.next(
					this.array_tipoContrato.slice()
				);
				this.filterTipoContrato.valueChanges
					.pipe(takeUntil(this._onDestroy))
					.subscribe(() => {
						this.filtrar_TipoContrato();
					});
			},
			(errorServicio) => {
				console.log(errorServicio);
			}
		);
	}

	filtrar_TipoContrato() {
		if (this.array_tipoContrato.length === 0) {
			return;
		}
		let search = this.filterTipoContrato.value;
		if (!search) {
			this.filtered_TipoContrato.next(this.array_tipoContrato.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_TipoContrato.next(
			this.array_tipoContrato.filter(
				(item) =>
					item.ModeloContratoDes.toLowerCase().indexOf(search) > -1
			)
		);
	}

	//#endregion

	//#region GUARDAR

	//#region VALIDAR NUEVA FECHA INICIO CONTRATO

	/*
		que la nueva fecha de inicio sea mayor que la fecha mayor del array
		de fechas de fin de contratos anteriores de todas las personas seleccionadas
	*/

	// validarNuevaFechaInicio(nuevaFechaInicio) : Boolean{
	// 	return nuevaFechaInicio > this.fechaMayor ? true : false;
	// }

	//#endregion

	save_update() {
		const _controls = this.formMACRO.controls;

		// if(!this.validarNuevaFechaInicio(_controls.FechaInicio.value)){
		// 	this.toastr.warningToastr(
		// 		"La nueva fecha de inicio de contrato tiene que ser mayor que la fecha mayor de fin de contratos anteriores.",
		// 		"Advertencia!",
		// 		{
		// 			toastTimeout: 3000,
		// 			showCloseButton: true,
		// 			animate: "fade",
		// 			progressBar: true,
		// 		}
		// 	);
		// 	//return;
		// }

		if (this.formMACRO.invalid) {
			Object.keys(_controls).forEach((controlName) =>
				_controls[controlName].markAsTouched()
			);
			this.toastr.warningToastr(
				"Ingrese los campos obligatorios.",
				"Advertencia!",
				{
					toastTimeout: 2000,
					showCloseButton: true,
					animate: "fade",
					progressBar: true,
				}
			);
			return;
		}

		let dataPersonal = this.data.datos;

		// fecha de inicio de prorroga >= fecha fin contrato

		let result = dataPersonal.filter(
			(item) =>
				this.datePipe.transform(
					_controls.FechaInicio.value,
					"yyyy-MM-dd"
				) < this.datePipe.transform(item.FinContrato, "yyyy-MM-dd")
		);

		if (result.length === 0) {
			this.viewLoading = true;


			let model ;
			if(this.chkPorDias.value &&  !this.FechasIguales){
				model = {
					chkPorDias: true,
					soloFechaDiferente: true,
					xml: this.generarXMLFechas()
				}
			}else{
				model = {
					chkPorDias: false,
					soloFechaDiferente: false,
					TipoContrato: _controls.TipoContrato.value,
					FechaInicio: this.datePipe.transform(
						_controls.FechaInicio.value,
						"yyyy-MM-dd"
					),
					FechaFin: this.datePipe.transform(
						_controls.FechaFin.value,
						"yyyy-MM-dd"
					),
					Personal: this.data.datos,
				};
			}

			this.trabajador_s._SaveProrrogaContratos(model).subscribe(
				(data: any) => {
					if (data[0].Status) {
						this.toastr.successToastr(data[0].Msg, "Éxito!", {
							toastTimeout: 2000,
							showCloseButton: true,
							animate: "fade",
							progressBar: true,
						});
					} else {
						this.toastr.warningToastr(data[0].Msg, "Advertencia!", {
							toastTimeout: 2000,
							showCloseButton: true,
							animate: "fade",
							progressBar: true,
						});
					}
					this.viewLoading = false;
					this.dialogRef.close({ rpta: true });
					return;
				},
				(errorServicio) => {
					this.toastr.errorToastr(errorServicio.message, "Error!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
					this.viewLoading = false;
					console.log(errorServicio);
				}
			);
		} else {
			this.dialogRef.close({ rpta: false, data: result });
			return;
		}
	}

	//#endregion

	//#region Armar XML de fechas
	generarXMLFechas(): string {
		const _controls = this.formMACRO.controls;

		let dias : number = _controls.DiasRenovarContrato.value;
		let xml: string = '<?xml version="1.0" encoding="ISO-8859-1"?><root>';
		this.ArraySeleccion
		.forEach((item) => {
			// const addDays = (date: Date, days: number): Date => {
			// 	let result = new Date(date);
			// 	result.setDate(result.getDate() + days);
			// 	return result;
			// };

			// const inicio : Date = addDays(item.FinContrato,1);
			// let fechaInicio = inicio.getFullYear() + '-' + inicio.getMonth() + '-' + inicio.getDate();
			// const fin : Date = addDays(inicio,dias+1);
			// let fechaFin = fin.getFullYear() + '-' + fin.getMonth() + '-' + fin.getDate();

			xml += "<DetaFechas ";
			xml +=
				'TipoContrato="' +
				_controls.TipoContrato.value +
				'" ' +
				'FechaFinContratoAnterior="' +
				item.FinContrato +
				'" ' +
				'Dias="' +
				dias +
				'" ' +
				'DNI="' +
				item.DNI +
				'" ' +
				'Postulante="' +
				item.Postulante +
				'" ' +
				" />";
		});
		xml += "</root>";
		return xml;
	}
	//#endregion

	//#region _zfill

	_zfill(number: number, width: number) {
		var numberOutput = Math.abs(number);
		var length = number.toString().length;
		var zero = "0";

		if (width <= length) {
			if (number < 0) {
				return "-" + numberOutput.toString();
			} else {
				return numberOutput.toString();
			}
		} else {
			if (number < 0) {
				return (
					"-" + zero.repeat(width - length) + numberOutput.toString()
				);
			} else {
				return zero.repeat(width - length) + numberOutput.toString();
			}
		}
	}

	//#endregion

}
